<template>
    <v-card>
        <div>
            <v-img
                :src="infoPosto.url_imagem_posto || require('@/assets/posto-default.png')"
                aspect-ratio="2.75"
            >
                <v-layout pa-2 column fill-height class="lightbox white--text">
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                        <v-btn
                            color="white"
                            dark
                            flat
                            @click="() => qrcode = !qrcode"
                        >
                            {{qrcode ? 'ESCONDER' : 'VER'}} QR-CODE
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-img>
        </div>
        <v-card-text>
            <template v-if="qrcode">
                <v-container grid-list-md fluid v-if="posto">
                  <v-layout row wrap fill-height>
                    <v-flex xs12 class="text-xs-center">
                      <span class="headline secondary--text">QR Code {{infoPosto.nome_fantasia}}</span>
                      <div>
                      <span class="headline secondary--text">CNPJ {{infoPosto.cnpj}}</span>
                      </div>
                      <v-layout justify-center align-center fill-height>
                        <template>
                          <qrcode-vue ref="qrcode" renderAs="svg" :value="link" size="300" level="H"></qrcode-vue>
                        </template>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                    <v-btn flat block color="primary" @click="exportSVG()">
                    Baixar
                    </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
            </template>
            <v-layout pt-4 row wrap justify-space-around fill-height>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="Razão Social"
                        v-model="infoPosto.razao_social"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="Nome Fantasia"
                        v-model="infoPosto.nome_fantasia"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-text-field
                        readonly
                        label="CNPJ"
                        v-model="infoPosto.cnpj"
                        mask="##.###.###/####-##"
                        class="text-xs-center"
                    ></v-text-field>
                </v-flex>
                <template v-if="posto && posto.representante">
                  <v-flex xs12 sm5>
                      <v-text-field
                          readonly
                          label="CPF do representante"
                          v-model="posto.representante.cpf"
                          mask="###.###.###-##"
                          class="text-xs-center"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Nome do Representante"
                          v-model="posto.representante.nome"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Sobrenome do Representante"
                          v-model="posto.representante.sobrenome"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Telefone do Representante"
                          v-model="posto.representante.telefone"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Email do Representante"
                          v-model="posto.representante.email"
                      ></v-text-field>
                  </v-flex>
              </template>
                <template v-if="posto && posto.endereco">
                  <v-flex xs12 class="text-xs-center pt-2 pb-2">Endereço</v-flex>
                  <v-flex xs8>
                      <v-text-field
                          readonly
                          label="Logradouro"
                          v-model="posto.endereco.logradouro"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                      <v-text-field
                          readonly
                          label="Número"
                          v-model="posto.endereco.numero"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Cidade"
                          v-model="posto.endereco.cidade"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Bairro"
                          v-model="posto.endereco.bairro"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                      <v-text-field
                          readonly
                          label="Estado"
                          v-model="posto.endereco.estado"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                      <v-text-field
                          readonly
                          label="País"
                          v-model="posto.endereco.pais"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                      <v-text-field
                          readonly
                          label="CEP"
                          v-model="posto.endereco.cep"
                          mask="#####-###"
                      ></v-text-field>
                  </v-flex>
                </template>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="$emit('fechar')">Voltar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import settings from '@/settings'
import { administradorDao } from '@/api'
import QrcodeVue from 'qrcode.vue'
import { saveAs } from 'file-saver'

export default {
  components: { QrcodeVue },
  props: ['posto'],
  data () {
    return {
      qrcode: false,
      infoPosto: {
        endereco: {},
        representante: {}
      }
    }
  },
  computed: {
    link () {
      return `${settings.apetrusGo}/${this.infoPosto.cnpj}/`
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  mounted () {
    if (this.posto) {
      this.carregarDados()
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.carregarDados()
      }
    }
  },
  methods: {
    exportSVG () {
      var svg = this.$refs.qrcode.$el
      // first create a clone of our svg node so we don't mess the original one
      var clone = svg.cloneNode(true)
      // parse the styles
      this.parseStyles(clone)

      // create a doctype
      var svgDocType = document.implementation.createDocumentType('svg', '-//W3C//DTD SVG 1.1//EN', 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd')
      // a fresh svg document
      var svgDoc = document.implementation.createDocument('http://www.w3.org/2000/svg', 'svg', svgDocType)
      // replace the documentElement with our clone
      svgDoc.replaceChild(clone, svgDoc.documentElement)
      // get the data
      var svgData = (new XMLSerializer()).serializeToString(svgDoc)

      // now you've got your svg data, the following will depend on how you want to download it
      // e.g yo could make a Blob of it for FileSaver.js
      /*
      var blob = new Blob([svgData.replace(/></g, '>\n\r<')])
      saveAs(blob, 'myAwesomeSVG.svg')
      */
      // here I'll just make a simple a with download attribute

      var blob = new Blob([svgData.replace(/></g, '>\n\r<')])
      saveAs(blob, `qrcode-${this.posto.nome_fantasia}.svg`)

      // var a = document.createElement('a')
      // a.href = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(svgData.replace(/></g, '>\n\r<'))
      // a.download = 'myAwesomeSVG.svg'
      // a.innerHTML = 'download the svg file'
      // document.body.appendChild(a)
    },
    parseStyles (svg) {
      var styleSheets = []
      var i
      // get the stylesheets of the document (ownerDocument in case svg is in <iframe> or <object>)
      var docStyles = svg.ownerDocument.styleSheets

      // transform the live StyleSheetList to an array to avoid endless loop
      for (i = 0; i < docStyles.length; i++) {
        styleSheets.push(docStyles[i])
      }

      if (!styleSheets.length) {
        return
      }

      var defs = svg.querySelector('defs') || document.createElementNS('http://www.w3.org/2000/svg', 'defs')
      if (!defs.parentNode) {
        svg.insertBefore(defs, svg.firstElementChild)
      }
      svg.matches = svg.matches || svg.webkitMatchesSelector || svg.mozMatchesSelector || svg.msMatchesSelector || svg.oMatchesSelector

      // iterate through all document's stylesheets
      for (i = 0; i < styleSheets.length; i++) {
        var currentStyle = styleSheets[i]

        var rules
        try {
          rules = currentStyle.cssRules
        } catch (e) {
          continue
        }
        // create a new style element
        var style = document.createElement('style')
        // some stylesheets can't be accessed and will throw a security error
        var l = rules && rules.length
        // iterate through each cssRules of this stylesheet
        for (var j = 0; j < l; j++) {
          // get the selector of this cssRules
          var selector = rules[j].selectorText
          // probably an external stylesheet we can't access
          if (!selector) {
            continue
          }

          // is it our svg node or one of its children ?
          if ((svg.matches && svg.matches(selector)) || svg.querySelector(selector)) {
            var cssText = rules[j].cssText
            // append it to our <style> node
            style.innerHTML += cssText + '\n'
          }
        }
        // if we got some rules
        if (style.innerHTML) {
          // append the style node to the clone's defs
          defs.appendChild(style)
        }
      }
    },
    carregarDados () {
      administradorDao.infoPosto(this.posto.cnpj, this.headers).then(response => {
        return response.json()
      }).then(json => {
        this.infoPosto = json
      })
    }
  }
}
</script>
<style>
  .v-navigation-drawer {
    transition: none !important;
  }

  .lightbox {
    box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
  }
</style>
